var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M4.549,19.107.171,14,2,12l3.834,3.006L17,3l2,1L7.664,19.011A2,2,0,0,1,4.549,19.107Z"}}),_c('rect',{attrs:{"x":"19","y":"7","width":"5","height":"2"}}),_c('rect',{attrs:{"x":"15","y":"12","width":"9","height":"2"}}),_c('rect',{attrs:{"x":"12","y":"17","width":"12","height":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }